var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{attrs:{"items":_vm.items,"fields":_vm.fields},on:{"row-clicked":_vm.showEditModal}}),_c('app-edit-user-modal',{ref:"AppEditUserModal",attrs:{"clicked-user":_vm.clickedUser},on:{"deleteUser":_vm.deleteUser,"updateUser":_vm.updateUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }